/**
 * This enum is used for referring Primary Navigation URL Path.
 */
export enum MainNavigationEnum {
  LOGIN = 'login',
  NO_ACCESS = 'no-access',
  UNAUTHORIZED = 'unauthorized',
  BULK_ROLE_ASSIGNMENT = 'bulk-role-assignment',
  USERS = 'users',
  TOKENS = 'tokens',
  CLIENTS = 'clients',
  HISTORICAL_PULL = 'historical-pull',
  CHAT_ADMIN = 'chat-admin',

  // Dev-only: shared-component library showcase (not in the side-nav)
  UI_SHOWCASE = 'ui-showcase',
}
